<template>
      
      <!-- Begin page -->
      <div id="wrapper">
            
            <!-- Top Bar Start -->
            <topbar></topbar>
            <!-- Top Bar End -->
            
            
            <!-- ========== Left Sidebar Start ========== -->
            
            <!-- Left Sidebar End -->
            <left></left>
            
            
            <!-- ============================================================== -->
            <!-- Start right Content here -->
            <!-- ============================================================== -->
            <div class="content-page">
                  <!-- Start content -->
                  <div class="content">
                        <div class="container-fluid">
                        
                              <div class="row">
                                    <div class="col-12">
                                          <div class="page-title-box">
                                                <h4 class="page-title float-left">考试专区</h4>
                                                <ol class="breadcrumb float-right">
                                                      <li class="breadcrumb-item"><a href="#">cpwm</a></li>
                                                      <li class="breadcrumb-item"><a href="#">考试专区</a></li>
                                                      <li class="breadcrumb-item active">考试报名</li>
                                                </ol>
                                          
                                                <div class="clearfix"></div>
                                          </div>
                                    </div>
                              </div>
                              <!-- end row -->
                        
                        
                              <div class="row">
                                    <div class="col-12">
                                          <div class="card-box">
                                                <h4 class="m-t-0 header-title" style="border-bottom: 1px solid #868686;padding-bottom: 10px;"><b style="font-size: 16px;margin-bottom: 10px;">考试费用支付</b></h4>
                                                <p class="text-muted m-b-30 font-14" style="color: #000000 !important;margin-top:28px;font-size:17px !important;">
                                                      您需要支付的考试费用为: <code style="font-size:16px !important; font-weight: bold">{{money}}元</code>
                                                </p>
                                                <p class="text-muted m-b-30 font-14" style="color: #000000 !important;margin-top:28px;font-size:17px !important;">
                                                      请选择付款方式
                                                </p>
                                                <p class="text-muted m-b-30 font-14" style="color: #000000 !important;margin-top:28px;font-size:15px !important;">
                                                      <img src="/member2/images/alipay.png" width="200px"  v-on:click="baoming('alipay')">
                                                </p>
                                                <p class="text-muted m-b-30 font-14" style="color: #000000 !important;margin-top:28px;font-size:15px !important;">
                                                      <img src="/member2/images/wechatpay.png" width="200px"   v-on:click="baoming('wechatpay')">
                                                </p>
      
                                                <p class="text-muted m-b-30 font-14" style="color: #000000 !important;margin-top:28px;font-size:17px !important;">
                                                      或者使用兑换码
                                                </p>
                                                <p class="text-muted m-b-30 font-14" style="color: #000000 !important;margin-top:28px;font-size:15px !important;">
                                                      <input type="text" name="country"
                                                             v-model="code"
                                                             class="form-control"
                                                             placeholder="请输入兑换码"
                                                             style="max-width: 410px;margin-top: 10px;"
                                                      >
                                                </p>
                                                <p  class="text-muted m-b-30 font-14" style="color: #000000 !important;margin-top:28px;font-size:17px !important;">
                                                      <button type="submit" style="margin: 0 auto;"
                                                              class="btn btn-gradient btn-rounded waves-light waves-effect w-md"
                                                              v-on:click="freecode">提交兑换码
                                                      </button>
                                                </p>
                                                <!-- end row -->
                                    
                                          </div> <!-- end card-box -->
                                    </div><!-- end col -->
                              </div>
                              <!-- end row -->
                          
                  
                        </div> <!-- container -->
            
                  </div> <!-- content -->
      
                  <!--footer-->
      
            </div>
            
            
            <!-- ============================================================== -->
            <!-- End Right content here -->
            <!-- ============================================================== -->
      
      
      </div>
      <!-- END wrapper -->


</template>

<script>
      import topbar from './topbar';
      import left from './left';
      export default {
            name: 'signup',
            components:{topbar,left},
            data() {
                  return {
                        money:this.money,
                        code:this.code,
                        
                        paystyle: this.paystyle,
                        //other
                        tishi:true
                  }
            },
            mounted(){
                  this.showmember();
            },
            methods: {
                  baoming: function (paystyle) {
                       this.paystyle=paystyle;
                        let data = {
                              paystyle: this.paystyle,
                        }
                        this.$axios({
                              method: "POST",
                              url: '/api/member2/pay',
                              data: data,
                              headers: {
                                    membertoken: localStorage.getItem('membertoken')
                              }
                        }).then(function OnSuccess(response) {
                              if (response.data.code === 0) {
                                    // 0-alipay wechatpay
                                    if (response.data.arr.paystyle === 'alipay') {
                                          console.log(response.data.arr.paystyle);
                                          window.location.href = '/api/member2/pay/alipay/' + response.data.arr.orderid;
                                    } else if (response.data.arr.paystyle === 'wechatpay') {
                                          if (this.isMobile()) {
                                                this.wechatpay_h5(response.data.arr.orderid);
                                          } else {
                                                //this.wechatpay(response.data.arr.orderid);
                                                window.location.href="/member2/#/signup_wechatpay_erweima/"+response.data.arr.orderid;
                                          }
                                          //this.isMobile();

                                    }


                              } else {
                                    alert(response.data.msg);
                              }

                        }.bind(this)).catch(function OnError() {

                        })

                  },
                  isMobile: function () {
                        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
                        console.log(flag);
                        return flag;
                  },
                 
                  
                  wechatpay_h5: function (orderid) {
                        this.$axios({
                              method: 'get',
                              url: '/api/member2/pay/wechatpay_h5/' + orderid
                        }).then(function onSuccess(response) {

                              if (response.data.code === 0) {
                                    window.location.href = response.data.mweburl;
                              }
                              console.log(response.data.code);

                        }.bind(this)).catch(function onError() {
                              alert('异常');
                        })
                  },
                  showmember: function () {

                        this.$axios({
                              method: 'get',
                              url: '/api/member2/member_show',
                              headers: {
                                    membertoken: localStorage.getItem('membertoken')
                              }
                        }).then(function OnSuccess(response) {
                              this.money=response.data.other.examination_money;
                        }.bind(this)).catch(function OnError() {

                        })

                  },
                  freecode:function () {
                        let data = {
                              id:this.id,
                              code:this.code,
                              money: 0,
                              paystyle: 'freecode',
                        }
                        this.$axios({
                              method: 'post',
                              data:data,
                              url: '/api/member2/pay/freecode_signup/',
                              headers: {
                                    membertoken: localStorage.getItem('membertoken')
                              }
                        }).then(function onSuccess(response) {

                              if (response.data.code === 0) {
                                    window.location.href = '/member2/#/signup_code';
                              }else{
                                    //alert(response.data.msg);
                                    swal(
                                          {
                                                title: response.data.msg,
                                                text: '',
                                                type: 'warning',
                                                confirmButtonColor: '#4fa7f3',
                                          }
                                    )
                              }

                        }.bind(this)).catch(function onError() {
                              alert('异常');
                        })
                  }
                  
                  //method over

            }
            //mounted over


      }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
      .zx{width:100%;}
      .zx li{width:100%;float: left}

  
     
</style>



// WEBPACK FOOTER //
// src/components/signup_pay.vue